var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "output",
    {
      staticClass:
        "run-status-chip d-inline-flex align-center pl-4 az-gap-small",
      attrs: { "aria-live": "polite" }
    },
    [
      _c(
        "span",
        {
          staticClass: "run-status-chip__estado d-inline-flex align-center",
          class: {
            "run-status-chip__estado--com-cancelar": _vm.mostrarBotaoCancelar,
            "run-status-chip__estado--em-curso": _vm.emCurso
          }
        },
        [
          _c("BaseStatus", {
            attrs: {
              soft: "",
              "preserve-case": "",
              content: _vm.rotulo,
              color: _vm.cor
            }
          }),
          _vm.emCurso
            ? _c("v-progress-circular", {
                staticClass: "run-status-chip__giro",
                attrs: {
                  indeterminate: "",
                  size: 10,
                  width: 2,
                  color: _vm.cor,
                  "aria-hidden": "true"
                }
              })
            : _vm._e(),
          _vm.mostrarBotaoCancelar
            ? _c(
                "button",
                {
                  staticClass:
                    "run-status-chip__cancelar d-inline-flex align-center justify-center",
                  attrs: {
                    type: "button",
                    title: _vm.ROTULO_CANCELAR,
                    "aria-label": _vm.ROTULO_CANCELAR
                  },
                  on: { click: _vm.onCancelar }
                },
                [
                  _c("icon-svg", {
                    attrs: {
                      name: "close-circle",
                      size: 12,
                      color: "var(--neutral-700)"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm.auxiliarDoEstadoAtual
        ? _c(
            "span",
            {
              staticClass:
                "run-status-chip__auxiliar az-text-secondary az-size-12 az-muted"
            },
            [_vm._v(" " + _vm._s(_vm.auxiliarDoEstadoAtual) + " ")]
          )
        : _vm._e(),
      _vm.mostrarContadorPropostas
        ? _c(
            "span",
            {
              staticClass:
                "run-status-chip__contador az-text-secondary az-size-12 az-muted"
            },
            [_vm._v(" " + _vm._s(_vm.textoContador) + " ")]
          )
        : _vm._e(),
      _vm.motivoTraduzido
        ? _c(
            "span",
            {
              staticClass:
                "run-status-chip__motivo az-text-secondary az-size-12 az-muted"
            },
            [_vm._v(" " + _vm._s(_vm.motivoTraduzido) + " ")]
          )
        : _vm._e(),
      _vm.tempoDecorridoTexto
        ? _c(
            "span",
            {
              staticClass:
                "run-status-chip__elapsed az-text-secondary az-size-12 az-muted"
            },
            [_vm._v(" " + _vm._s(_vm.tempoDecorridoTexto) + " ")]
          )
        : _vm._e(),
      _vm.mostrarCreditos
        ? _c(
            "span",
            {
              staticClass:
                "run-status-chip__creditos az-text-secondary az-size-12 az-muted"
            },
            [_vm._v(" " + _vm._s(_vm.textoCreditos) + " ")]
          )
        : _vm._e(),
      _vm.mostrarEfeitos
        ? _c(
            "span",
            {
              staticClass:
                "run-status-chip__efeitos az-text-secondary az-size-12 az-muted"
            },
            [_vm._v(" " + _vm._s(_vm.textoEfeitos) + " ")]
          )
        : _vm._e(),
      _vm.mostrarBotaoTentarDeNovo
        ? _c(
            "BaseButton",
            {
              attrs: {
                underlined: "",
                sm: "",
                fitContent: "",
                loading: _vm.carregandoTentativa,
                disabled: _vm.carregandoTentativa,
                "aria-label": "Tentar de novo"
              },
              on: { click: _vm.onTentarDeNovo }
            },
            [_vm._v("Tentar de novo")]
          )
        : _vm._e(),
      _vm.mostrarBotaoAprovarTodas
        ? _c(
            "BaseButton",
            {
              attrs: {
                primary: "",
                sm: "",
                fitContent: "",
                loading: _vm.aprovandoTodas,
                disabled: _vm.aprovandoTodas,
                "aria-label": _vm.ariaAprovarTodas
              },
              on: { click: _vm.onAprovarTodas }
            },
            [_vm._v(" " + _vm._s(_vm.textoAprovarTodas) + " ")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }